import { Avatar, ButtonBase, Skeleton, Stack, Typography } from '@mui/material'
import React from 'react'

export type FilterButtonProps = {
  backgroundImageUrl?: string
  title: string
  subtitle?: string
  backgroundColor?: string
  quantity: number
  category: string
  value: string
  backgroundIcon?: React.ReactElement
  onClick?: (category: string, value: string) => void
  selected?: boolean
  loading: boolean
}

const FilterButton: React.FC<FilterButtonProps> = ({
  backgroundImageUrl,
  backgroundColor,
  backgroundIcon,
  title,
  subtitle,
  quantity,
  value,
  category,
  selected,
  loading,
  onClick = () => {},
}) => {
  const disabled = quantity <= 0
  const disabledBgColor = 'rgba(255, 255, 255, 0.7)'
  const textColor = disabled ? 'text.disabled' : 'inverted.main'
  return (
    <ButtonBase
      onClick={() => onClick(category, value)}
      disabled={disabled}
      sx={{
        overflow: 'hidden',
        width: '100%',
        minHeight: '65px',
        backgroundColor: backgroundColor || 'secondary.light',
        ...(selected && { boxShadow: '0px 0px 3px primary.main' }),
        ':before': {
          content: '""',
          display: 'block',
          position: 'absolute',
          borderRadius: '6px',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          ...(disabled && { backgroundColor: disabledBgColor }),
          ...(selected && !disabled && { backgroundColor: 'rgba(63, 65, 68, 0.8)' }),
          ...(backgroundImageUrl &&
            selected &&
            !disabled && { backgroundColor: 'rgba(63, 65, 68, 0.9)' }),
          ...(backgroundImageUrl && !selected && { backgroundColor: 'rgba(63, 65, 68, 0.5)' }),
        },
        borderRadius: '6px',
        justifyContent: 'left',
        ...(backgroundImageUrl && {
          backgroundImage: `url("${backgroundImageUrl}")`,
        }),
      }}
    >
      <Stack alignItems="center" marginLeft={2} spacing={1} direction="row">
        <Avatar
          sx={{
            background: 'none',
            borderColor: selected ? 'primary.light' : textColor,
            borderWidth: '0.5px',
            borderStyle: 'solid',
            color: selected ? 'primary.light' : textColor,
          }}
        >
          {loading ? <Skeleton variant="circular" width={26} /> : quantity}
        </Avatar>
        <Stack textAlign="left" zIndex={1} alignItems="flex-start" direction="column">
          <Typography
            position="relative"
            color={selected ? 'primary.light' : textColor}
            variant="body1"
          >
            {title}
          </Typography>
          {subtitle ? (
            <Typography
              position="relative"
              color={selected ? 'primary.light' : textColor}
              variant="body2"
            >
              {subtitle}
            </Typography>
          ) : null}
        </Stack>
      </Stack>
      {backgroundIcon ? (
        <div style={{ position: 'absolute', right: 0, color: 'rgb(0,0,0,0.2)' }}>
          {backgroundIcon}
        </div>
      ) : null}
    </ButtonBase>
  )
}

export default FilterButton
